import React, { useState } from "react";
import { useNavigate } from "react-router";
import DEVELOPMENT_CONFIG from "../../helper/config";
import { NotificationManager } from "src/util/notify";
import { useDispatch } from "react-redux";
import ErrorHelper from "../../helper/error-helper";
import "../../custom-css/custom-style.css";
import { Navigate } from "react-router-dom";
import Loader from "../../control-components/loader/loader";
import APP_ROUTES from "../../helper/app-routes";
import PhoneInputMask from "../../control-components/phone-input-mask/phone-input-mask";
import { AuthService } from "../../services/authService";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { Form } from "react-bootstrap-v5";

let token = localStorage.getItem(DEVELOPMENT_CONFIG.TOKEN);
const countryCodes = ["+91", "+1"];

function LogIn() {
  const navigate = useNavigate();
  const [errors, setErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [settingError, setSettingError] = useState(false);
  let [fields, setFields] = useState({
    countryCode: "+1",
    phone: "",
  });

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      event.preventDefault();
      postLogin();
    }
  };

  const postLogin = async () => {
    setLoading(true);
    await AuthService.appLogIn(fields)
      .then((result) => {
        setLoading(false);
        navigate(APP_ROUTES.CONFIRM_OTP, {
          state: { fields },
        });
        NotificationManager.success(
          "OTP has been sent to your registered mobile"
        );
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;
    if (fields.phone.trim().length !== 10) {
      formIsValid = false;
      errors["phone"] = ErrorHelper.MOBILE_PHONE;
    }
    if (!fields.countryCode) {
      formIsValid = false;
      errors["countryCode"] = ErrorHelper.COUNTRY_CODE;
    }
    setErrors(errors);
    return formIsValid;
  };

  const handleValueChange = (e) => {
    const name = e.target.name;
    const rawValue = e.target.rawValue;
    setFields({
      ...fields,
      [name]: rawValue,
    });
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  if (token != null) {
    return <Navigate to={APP_ROUTES.DASHBOARD} />;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="login-form">
        <div className="container-fluid">
          <div className="row example-wrapper">
            <div className="col-md-8 col-lg-6 col-xl-5 mx-auto">
              <h1>notenetic</h1>

              <div className="inner-login-notenetic">
                <h2>Sign in to your account</h2>
                <div className="react-login">
                  <DropDownKendoRct
                    value={fields.countryCode}
                    onChange={handleChange}
                    data={countryCodes}
                    suggest={true}
                    name="countryCode"
                    required={true}
                    validityStyles={settingError}
                    error={!fields.countryCode && errors.countryCode}
                    placeholder="Country Code"
                  />
                  <PhoneInputMask
                    validityStyles={settingError}
                    onChange={handleValueChange}
                    name="phone"
                    value={fields.phone == null ? "" : fields.phone}
                    error={fields.phone && errors.phone}
                    required={true}
                    placeholder="Mobile Phone"
                  />
                </div>

                <div className="list-check d-flex align-items-center"></div>
                <button
                  type="submit"
                  className="green-btn btn-primary"
                  onClick={handleSubmit}
                >
                  {loading ? "Submitting" : "Submit"}
                </button>
                {loading == true && <Loader />}
              </div>

            </div>
          </div>
        </div>
      </div>
    </form>

  );
}
export default LogIn;
